<div class="col section-2" *ngIf="customerByIdData" style="font-size: 14px;">    
    <h2 class="section-2-heading">Service Agreement
    </h2>
    <mat-divider></mat-divider>
    <ng-container>
      <div>
        <div>
          <h2 class="company-info-heading mt-3 mb-3">
            Company Information
          </h2>
          <div class="companyInfo row">
            <div class="col-md-6 col-sm-12">
              <p>
                <label>Company Name:</label>
                {{ customerByIdData.CompanyName }}
              </p>
              <p>
                <label>Mailing Address:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .MailingAddress.StreetName
                }}
              </p>
              <p>
                <label>City:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .MailingAddress.City
                }}
              </p>
              <p>
                <label>State:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .MailingAddress.State
                }}
              </p>
              <p>
                <label>Zip:</label>
                {{
                GetZipFormat(customerByIdData.JSONCustomerDetails.CompanyDetails
                .MailingAddress.Zip)
                }}
              </p>
              <p>
                <label>Same As Mailing:</label>{{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .PhysicalAddressSameAsMailingAddress? 'YES' : 'NO'
                }}
              </p>
              <p>
                <label>Physical Address: </label>{{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .PhysicalAddress.StreetName
                }}
              </p>
              <p>
                <label>City: </label>{{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .PhysicalAddress.City
                }}
              </p>
              <p>
                <label>State:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .PhysicalAddress.State
                }}
              </p>
              <p>
                <label>Zip:</label>
                {{
                GetZipFormat(customerByIdData.JSONCustomerDetails.CompanyDetails
                .PhysicalAddress.Zip)
                }}
              </p>
              <p><label>Affiliate Company Name:</label>
                {{customerByIdData.JSONCustomerDetails.CompanyDetails.AffiliatedCompanyName?customerByIdData.JSONCustomerDetails.CompanyDetails.AffiliatedCompanyName: 'None'}}</p>
              <p><label>Reinstatement Account:</label>
                {{customerByIdData.JSONCustomerDetails.CompanyDetails.ReinstatedAccountNumber?customerByIdData.JSONCustomerDetails.CompanyDetails.ReinstatedAccountNumber:'None'}}</p>

            </div>
            <div class="col-md-6 col-sm-12">
             <p>
                <label>IsNetworld Account No:</label>
                {{ GetISNFormat(customerByIdData.JSONCustomerDetails.CompanyDetails.IsNetworldAccountNo) }}
              </p>
              <p>
                <label>ITS Account No:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .ITSAccountNumber
                }}
              </p>
              <p>
                <label>Type Of Work:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .TypeOfWork
                }}
              </p>
              <p>
                <label>Federal Tax ID:</label>
                {{
                GetFederalTaxFormat(customerByIdData.JSONCustomerDetails.CompanyDetails
                .FederalTaxID)
                }}
              </p>

              <p>
                <label>Are you an Oil & Gas Operator:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .IsOilAndGasOperator? 'YES' : 'NO'
                }}
              </p>
              <p>
                <label>List the Oil & Gas Operators you work for:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .OilAndGasOperatorCompanyNames
                }}
              </p>
              <p>
                <label>Sub Contractor Company Names:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .SubContractorCompanyNames
                }}
              </p>
              <p><label>List of Auditing Agencies:</label>                   
                {{ customerByIdData.JSONCustomerDetails.AuditAgencies === null? '' :
                customerByIdData.JSONCustomerDetails.AuditAgencies.join(", ")}}</p>
              <p>
                <label>Hear About PTC:</label>
                {{
                HearAboutValue
                }}
              </p>
              <p>
                <label>Hear About PTC Other:</label>
                {{
                customerByIdData.JSONCustomerDetails.CompanyDetails
                .HearAboutPTCOther
                }}
              </p>                      
            </div>
          </div>
        </div>
        <div>
          <h2 class="company-info-heading mt-3 mb-3">
            Designated Employee Representative (DER)


            <!-- <button class="tooltip_btn"
              
            kendoTooltip
            [tooltipTemplate]="htmlContent2"
            
              placement ="auto"
              data-html="true"
            >
            <i class="fa fa-info-circle"></i>
            </button> -->
          </h2>
          <div class="companyInfo row">
            <div class="col-md-6 col-sm-12">
              <p>
                <label>DER Name:</label>
                {{ customerByIdData.JSONCustomerDetails.DERs[0].Name }}
              </p>
              <p>
                <label>DER Phone No:</label>
                {{
                GetPhoneNoFormat(customerByIdData.JSONCustomerDetails.DERs[0].Address?customerByIdData.JSONCustomerDetails.DERs[0].Address.PhoneNumber:'')
                }}
              </p>
              <p>
                <label>DER Ext No:</label>
                {{
                customerByIdData.JSONCustomerDetails.DERs[0].Address?customerByIdData.JSONCustomerDetails.DERs[0].Address
                .Extension:''
                }}
              </p>
              <p>
                <label>DER Cell No:</label>
                {{
                GetPhoneNoFormat( customerByIdData.JSONCustomerDetails.DERs[0].Address?customerByIdData.JSONCustomerDetails.DERs[0].Address
                .MobileNumber:'')
                }}
              </p>
              <p>
                <label>DER Email:</label>
                {{
                customerByIdData.JSONCustomerDetails.DERs[0]
                .EmailAddress
                }}
              </p>
              <p>
                <label>DER Fax:</label>
                {{
                GetFaxNoFormat(customerByIdData.JSONCustomerDetails.DERs[0].Address?customerByIdData.JSONCustomerDetails.DERs[0].Address
                .FaxNumber:'')
                }}
              </p>
            </div>
            <div class="col-md-6 col-sm-12">
              <p>
                <label>DER Title:</label>
                {{ customerByIdData.JSONCustomerDetails.DERs.length>0?customerByIdData.JSONCustomerDetails.DERs[0].Title:'' }}
              </p>
              
              <p>
                <label>Alt. DER Name:</label>
                {{ customerByIdData.JSONCustomerDetails.DERs.length===2?customerByIdData.JSONCustomerDetails.DERs[1].Name:'' }}
              </p>
              <p>
                <label>Alt. DER Phone No:</label>
                {{
                GetPhoneNoFormat(customerByIdData.JSONCustomerDetails.DERs.length===2?customerByIdData.JSONCustomerDetails.DERs[1].Address
                .PhoneNumber:'')
                }}
              </p>
              <p>
                <label>Alt. DER Ext No:&nbsp;</label>
                {{
                customerByIdData.JSONCustomerDetails.DERs.length===2?customerByIdData.JSONCustomerDetails.DERs[1].Address
                .Extension:''
                }}
              </p>
              <p>
                <label>Alt. DER Cell No:</label>
                {{
                GetPhoneNoFormat(customerByIdData.JSONCustomerDetails.DERs.length===2?customerByIdData.JSONCustomerDetails.DERs[1].Address
                .MobileNumber:'')
                }}
              </p>
              <p>
                <label>Alt. DER Email:</label>
                {{
                customerByIdData.JSONCustomerDetails.DERs.length===2?customerByIdData.JSONCustomerDetails.DERs[1]
                .EmailAddress:''
                }}
              </p>
            </div>
          </div>
        </div>
        <div>
          <h2 class="company-info-heading mt-3 mb-3">
            Billing Contact
          </h2>
          <div class="companyInfo row">
            <div class="col-md-6 col-sm-12">
              <p>
                <label>Contact Name:</label>
                {{
                customerByIdData.JSONCustomerDetails
                .BillingContacts.length > 0? customerByIdData.JSONCustomerDetails
                .BillingContacts[0].Name:''
                }}
              </p>
              <p>
                <label>Billing Address:</label>
                {{
                  customerByIdData.JSONCustomerDetails
                  .BillingContacts.length > 0?customerByIdData.JSONCustomerDetails
                .BillingContacts[0].Address.StreetName:''
                }}
              </p>
              <p>
                <label>State:</label>
                {{
                  customerByIdData.JSONCustomerDetails
                  .BillingContacts.length > 0?customerByIdData.JSONCustomerDetails
                .BillingContacts[0].Address.State:''
                }}
              </p>
              <p>
                <label>Billing Phone No.:</label>
                {{
                GetPhoneNoFormat(customerByIdData.JSONCustomerDetails
                .BillingContacts.length > 0?customerByIdData.JSONCustomerDetails
                .BillingContacts[0].Address.PhoneNumber:'')
                }}
              </p>
              <p>
                <label>Alt. Contact Name:</label>
                {{
                  customerByIdData.JSONCustomerDetails
                  .BillingContacts.length > 1?customerByIdData.JSONCustomerDetails
                .BillingContacts[1].Name:''
                }}
              </p>
              <p>
                <label>Phone No.:</label>
                {{
                GetPhoneNoFormat(customerByIdData.JSONCustomerDetails
                .BillingContacts.length > 1?customerByIdData.JSONCustomerDetails
                .BillingContacts[1].Address.PhoneNumber:'')
                }}
              </p>
            </div>
            <div class="col-md-6 col-sm-12">
              <p>
                <label>Contact Email:</label>
                {{
                  customerByIdData.JSONCustomerDetails
                  .BillingContacts.length > 0?customerByIdData.JSONCustomerDetails
                .BillingContacts[0].EmailAddress:''
                }}
              </p>
              <p>
                <label>City:</label>
                {{
                  customerByIdData.JSONCustomerDetails
                  .BillingContacts.length > 0?customerByIdData.JSONCustomerDetails
                .BillingContacts[0].Address.City:''
                }}
              </p>

              <p>
                <label>Zip:</label>
                {{
                GetZipFormat(customerByIdData.JSONCustomerDetails
                .BillingContacts.length > 0?customerByIdData.JSONCustomerDetails
                .BillingContacts[0].Address.Zip:'')
                }}
              </p>
              <p>
                <label>Billing Fax No:</label>
                {{
                GetFaxNoFormat(customerByIdData.JSONCustomerDetails
                .BillingContacts.length > 0?customerByIdData.JSONCustomerDetails
                .BillingContacts[0].Address.FaxNumber:'')
                }}
              </p>
              <p>
                <label>Email:</label>
                {{
                  customerByIdData.JSONCustomerDetails
                  .BillingContacts.length > 1?customerByIdData.JSONCustomerDetails
                .BillingContacts[1].EmailAddress:''
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="page-break">
      <h2 class="section-2-heading">Program Information</h2>
      <mat-divider></mat-divider>
      <div class="companyInfo row">
        <div class="col-md-12 col-sm-12">
          <h2 class="company-info-heading mt-3 mb-3">
            Federal Program
          </h2>
          <p>
            <label>Federal Programs:&nbsp;</label>{{
            FederalPrgramsSelected
            }}
          </p>
          <p>
            <label>List of Auditors:&nbsp;</label>{{
            customerByIdData.JSONCustomerDetails.Auditors === null? ''
            :customerByIdData.JSONCustomerDetails.Auditors.join(", ")
            }}
          </p>
          <p>
            <label>Number Of Employees:&nbsp;</label>{{
            customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .FederalProgram.NumberOfEmployees
            }}
          </p>
          <p>
            <label>Federal CDL:&nbsp;</label>{{
            customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .FederalProgram.FederalCDL
            ? 'YES'
            : 'NO'
            }}
          </p>
          <table class="table table-light table-bordered mt-1">
            <tr>
              <th>Title</th>
              <th>Supervisor Position</th>
              <th>CDL</th>
            </tr>
            <tr *ngFor="
                let item of customerByIdData.JSONCustomerDetails
                  .PTCProgramDetails.FederalProgram.Employees;
                let i = index
              " [attr.data-index]="i">
              <td>{{ item.Title }}</td>
              <td>{{ item.IsSupervisor? 'Yes': 'No' }}</td>
              <td>{{ item.CDL? 'Yes': 'No' }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="companyInfo row">
        <div class="col-md-12 col-sm-12">
          <h2 class="company-info-heading mt-3 mb-3">
            Company Program
          </h2>
          <p>
            <label>Random Testing:&nbsp;</label>{{
            customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .CompanyProgram.IsRandomTesting
            ? 'YES'
            : 'NO'
            }}
          </p>
          <p>
            <label>Random Drug And Alcohol Testing:&nbsp;</label>{{
            customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .CompanyProgram.IsRandomDrugAndAlcoholTesting
            ? 'YES'
            : 'NO'
            }}
          </p>
          <p>
            <label>Drug Test Panel:&nbsp;</label>{{
            DrugTestPanelValue
            }}
          </p>
          <p>
            <label>Number Of Employees:&nbsp;</label>{{
            customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .CompanyProgram.NumberOfEmployees
            }}
          </p>
          <table class="table table-light table-bordered mt-1">
            <tr>
              <th>Title</th>
              <th>Supervisor Position</th>
            </tr>
            <tr *ngFor="
                let item of customerByIdData.JSONCustomerDetails
                  .PTCProgramDetails.CompanyProgram.Employees;
                let i = index
              " [attr.data-index]="i">
              <td>{{ item.Title }}</td>
              <td>{{ item.IsSupervisor? 'Yes': 'No' }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="companyInfo row">
        <div class="col-md-12 col-sm-12">
          <h2 class="company-info-heading mt-3 mb-3">Other Programs</h2>
          <p>
            <label> Programs:&nbsp;</label>{{
            ClientProgramSelected
            }}
          </p>
          <p>
            <label>Other Name:&nbsp;</label>{{
            customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .OtherProgram.OtherName
            }}
          </p>
          <p>
            <label>Number Of Employees:&nbsp;</label>{{
            customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .OtherProgram.NumberOfEmployees
            }}
          </p>
        </div>
      </div>
    </div>

    <div class="page-break acknowled">
      <h2 class="section-2-heading">Acknowledgments</h2>
      <mat-divider></mat-divider>

      <div class="companyInfo row mt-2">
        <div class="col-md-12 col-sm-12">
          <h2 class="company-info-heading mt-2 mb-3">No Refund & Credit Policy</h2>
          <p>Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason, we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually and the account may be subject to hold. In the event the company fails to make payments of amounts due under this agreement, PTC is authorized to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration, or other fees provided under this agreement.</p>

          <h2 class="company-info-heading mt-3 mb-3">Electronic Transmission Acknowledgment</h2>
          <p>This is to confirm your company's permission to use web or e-mail as a means of receiving test
            results, as opposed to calling the test results out by phone. As the contracted agent, Pipeline
            Testing Consortium, Inc. maintains all original records on behalf of your company. The guidelines
            will be as follows: </p>
          <p>• Individual expectations of privacy and confidentiality must be carefully maintained. Any
            transmission is confidential and is intended only for the use of the individual or entity
            identified. If the reader of the communication is not the intended recipient, they are hereby
            notified that dissemination or distribution of the data contained therein is prohibited under
            federal and state laws. </p>
          <p> Please acknowledge that you have read the above requirements/ restrictions for giving / receiving
            tests results via web or e-mail. </p>

          <h2 class="company-info-heading mt-3 mb-3">Consumer Report Service Agreement for Employers Subject to
            Substance Abuse Testing Verification Requirements</h2>
          <p>(hereinafter "{{CompanyName}}") and PTC Assist, LLC have entered into a Consumer Report Service
            Agreement (hereinafter "Agreement") through which {{CompanyName}} will utilize PTC Assist to obtain
            consumer reports for employment purposes. {{CompanyName}} and PTC Assist mutually desire to add the
            authorization provisions set forth below to the scope of that Agreement.
          </p>
        </div>
      </div>

    </div>
    <div class="page-break acknowled">
      <p> {{CompanyName}} is subject to drug and alcohol testing requirements under federal, state, or local laws,
        including those enforced by the U.S. Department of Transportation. {{CompanyName}} understands that compliance
        with these requirements includes verifying the drug and alcohol testing record of certain of its
        employees or prospective employees. In addition, {{CompanyName}} understands that these requirements impose an
        obligation on {{CompanyName}} to disclose information regarding the testing history of its current or former
        employees in response to verification requests from other employers also subject to these requirements.
        {{CompanyName}} has determined to utilize a consortium / third party administrator(hereinafter "TPA"), to act as
        {{CompanyName}}'s agent in complying with its alcohol and drug testing requirements. {{CompanyName}}'s TPA is as follows:
      </p>
      <p>Third Party Administrator: Pipeline Testing Consortium, Inc.<br />Contact Address: 9 Compound Drive,
        Hutchinson, KS 67502<br />Contact Phone: 620 - 669 - 8800</p>
      <p>For the mutual benefit of {{CompanyName}} and PTC Assist, {{CompanyName}} provides the following additional
        authorizations:</p>

      <p>Whether in response to a request from {{CompanyName}} or from another employer also subject to the drug and
        alcohol testing requirements, {{CompanyName}} authorizes PTC Assist to communicate directly with TPA to obtain
        information regarding the alcohol or drug testing record of any of {{CompanyName}}'s current or former employees.
      </p>
      <p>{{CompanyName}} authorizes TPA to release to PTC Assist any information that {{CompanyName}} would be required to release
        in response to a drug and alcohol testing record verification request regarding any current or former
        employee of {{CompanyName}}'s. {{CompanyName}} further authorizes PTC Assist to share a copy of this Addendum with TPA, on
        request, to confirm {{CompanyName}}'s authorization.</p>
      <p>So that TPA may maintain accurate records for {{CompanyName}}, {{CompanyName}} authorizes PTC Assist to share the results
        of its testing verifications directly with TPA.</p>
      <p>The authorizations set forth above shall remain in effect until the termination of the Agreement.</p>

      <!-- //let signedDate = new Date(this.AckAndAgreement.AckDate); //use your date here
    //let currentDate =this.datePipe.transform(signedDate, 'MM/dd/yyyy'); -->

      <p style='font-size:13px;font-weight:bold;'>I Agree By checking the "I Accept" box, you are signing these
        acknowledgments and policies electronically. You agree your electronic signature is the legal equivalent
        of your manual/handwritten signature on these documents. By selecting "I Accept" using any device,
        means, or action, you consent to the legally binding terms and conditions of these documents. You
        further agree that your electronic signature on this document is as valid as if you signed these
        documents in writing.</p>
      <div class="row mx-0 pt-4">
        <div>
          <div style="padding-bottom:5px; font-weight: normal;">{{CompanyName}}</div>
          <div style="border-top:1px solid #000; padding-top:5px; font-weight: 700;">
            Company Name
          </div>
        </div>

        <div class="ml-auto">
          <div style="padding-bottom:5px; font-weight: normal;">{{AckAndAgreementValue.CompanyRepresentativeName}}</div>
          <div style="border-top:1px solid #000; padding-top:5px; font-weight: 700;">
            Name of Authorized Company Representative
          </div>
        </div>

        <div class="ml-auto">
          <div style="padding-bottom:5px;  font-weight: normal;">{{AckDate}}</div>
          <div style="border-top:1px solid #000; padding-top:5px; font-weight: 700;">
            Date
          </div>
        </div>
      </div>
      <!-- <div style="float:left; width:250px; margin-right:30px"><div  style="padding-bottom:5px"></div>
    <div style="border-top:1px solid #000;padding-top:5px"><b>Company Name</b></div></div> 
    <div style="float:left; width:250px; margin-right:30px;"> <div style="padding-bottom:5px"></div>

    <div style="border-top:1px solid #000;padding-top:5px"><b>Name of Authorized Company Representative</b></div></div>
    <div style="float:right; width:160px;"><div style="padding-bottom:5px"></div>
    <div style="border-top:1px solid #000; padding-top:5px"><b>Date</b></div>
    </div> -->

    </div>

    <div class="page-break">
      <h2 class="section-2-heading">Summary</h2>
      <mat-divider></mat-divider>
      <div class="companyInfo row mt-4">
        <div class="col-md-12 col-sm-12">
          <p>
            <label>Company Name:&nbsp;</label>
            {{customerByIdData.JSONCustomerDetails.CompanyDetails.CompanyName}}
          </p>
          <p><label>Affiliate Company Name:</label>
            {{customerByIdData.JSONCustomerDetails.CompanyDetails.AffiliatedCompanyName?customerByIdData.JSONCustomerDetails.CompanyDetails.AffiliatedCompanyName: 'None'}}</p>
          <p><label>Reinstatement Account:</label>
            {{customerByIdData.JSONCustomerDetails.CompanyDetails.ReinstatedAccountNumber?customerByIdData.JSONCustomerDetails.CompanyDetails.ReinstatedAccountNumber:'None'}}</p>
          <p>
            <label>Address:</label>
            {{
            customerByIdData.JSONCustomerDetails.CompanyDetails
            .MailingAddress.StreetName !=null? customerByIdData.JSONCustomerDetails.CompanyDetails
            .MailingAddress.StreetName +
            ",
            " +
            customerByIdData.JSONCustomerDetails.CompanyDetails
            .MailingAddress.City +
            ", " +
            customerByIdData.JSONCustomerDetails.CompanyDetails
            .MailingAddress.State +
            ", " +
            GetZipFormat(customerByIdData.JSONCustomerDetails.CompanyDetails
            .MailingAddress.Zip):''
            }}
          </p>
          <p>
            <label>DER:&nbsp;</label>
            {{ customerByIdData.JSONCustomerDetails.DERs[0].Name }}
          </p>
          <p>
            <label>PhoneNo:</label>
            {{
            GetPhoneNoFormat(customerByIdData.JSONCustomerDetails.DERs[0].Address?customerByIdData.JSONCustomerDetails.DERs[0].Address
            .PhoneNumber:'')
            }}
          </p>
          <p>
            <label>Email:</label>
            {{
              customerByIdData.JSONCustomerDetails.DERs[0].EmailAddress?customerByIdData.JSONCustomerDetails.DERs[0].EmailAddress:''
            }}
          </p>
          <p>
            <label>Main Billing Contact:</label>
            {{
              customerByIdData.JSONCustomerDetails.BillingContacts.length >0?customerByIdData.JSONCustomerDetails.BillingContacts[0].Name:''
            }}
          </p>
          <p><label>Programs Requested:</label>{{InvoiceNumber? ProgramsRequested: ''}}</p>
          <p>
            <label># of Employees in a Random Pool:</label>
            {{TotalEmployees}}
          </p>
          <p><label>Payment Method:</label>
            {{InvoiceNumber? (customerByIdData.JSONCustomerDetails.PaymentDetails.IsCreditCard? 'Credit Card':'Check'):''}}
          </p>
          <p *ngIf="customerByIdData.JSONCustomerDetails.PaymentDetails.IsCreditCard">
            <label>Credit Card (Last 4 digits):</label>
            {{
            customerByIdData.JSONCustomerDetails.PaymentDetails.CreditCardDetails.CardNumber
            }}
          </p>
          <p *ngIf="customerByIdData.JSONCustomerDetails.PaymentDetails.IsCreditCard">
            <label>Transaction ID:</label>
            {{
            customerByIdData.JSONCustomerDetails.RepayTransactionId
            }}
          </p>
          <p *ngIf="customerByIdData.JSONCustomerDetails.PaymentDetails.IsCreditCard">
            <label>GUID:</label>
            {{
            customerByIdData.GUID
            }}
          </p>
          <p>
            <label>Invoice Number:</label>
            {{
            customerByIdData.JSONCustomerDetails.InvoiceNumber
            }}
          </p>
          <p>
            <label>Setup Fee:</label>(one time) ${{
            customerByIdData.JSONCustomerDetails.FeeDetails.SetupFee.toFixed(2)
            }}
          </p>
          <p>
            <label>Annual Subscription:</label> ${{
            customerByIdData.JSONCustomerDetails.FeeDetails.AnnualSubscription.toFixed(2)
            }}
          </p>
          <p>
            <label>Annual Employee
              Fee*:&nbsp;</label>${{AnnualEmployeeFee.toFixed(2)}}
          </p>
          <!-- <p>
            <label
              >>(18 employees in a random pool x $30 per)$540</label
            >
          </p> -->
          
          <p><label>Shipping & Handling:</label> ${{ customerByIdData.JSONCustomerDetails.FeeDetails.ExpeditedShippingFee.toFixed(2)}}</p>
          <p><label>SalesTax({{SalesTax>0?SalesTaxPercent:0}}%):</label> ${{ SalesTax.toFixed(2) }}</p>
          <p class="mt-3"><label>Enrollment Total**: ${{EnrollmentTotal}}</label></p>
          
          <h5 _ngcontent-ijn-c460="" class="mb-1">*The annual employee fee is calculated based on the average
            number of employees during the previous 12 months at a rate of $30.00 per employee, with a maximum
            annual employee fee of $6,000.00</h5>
          <h5 _ngcontent-ijn-c460="" class="mb-0">**All South Dakota based accounts are subject to sales
            tax. Completing and submitting this enrollment authorizes PTC to charge the applicable sales tax
            rate based upon your jurisdiction at the time the credit card is processed or invoice is issued.
          </h5>
          <!-- <p>
            <label
              >Total:
              {{
                customerByIdData.JSONCustomerDetails.FeeDetails
                  .EnrollmentTotal
              }}</label
            >
          </p> -->
          <h2 class="company-info-heading mt-3 mb-3">Per Use Fees</h2>
          <p *ngIf="objProgramSelection.DotFederal  == true || objProgramSelection.NonDotCompnay == true">
            <label>Drug Test:</label> ${{
            customerByIdData.JSONCustomerDetails.FeeDetails.DrugTest.toFixed(2)
            }}
          </p>
          <p *ngIf="lstCheckBoxClientRequiremets[4].isSelected">
            <label>ExxonMobil Drug Test:</label> ${{
            customerByIdData.JSONCustomerDetails.FeeDetails
            .ExxonMobilDrugTest.toFixed(2)
            }}
          </p>
          <p *ngIf="objProgramSelection.DotFederal  == true || objProgramSelection.NonDotCompnay == true">
            <label>Alcohol Test:</label> ${{
            customerByIdData.JSONCustomerDetails.FeeDetails
            .AlcoholTest.toFixed(2)
            }}
          </p>
          <p *ngIf="objProgramSelection.DotFederal  == true || objProgramSelection.NonDotCompnay == true">
            <label>Drug/Alcohol History Check:</label> ${{
            customerByIdData.JSONCustomerDetails.FeeDetails
            .DOTHistoryCheck.toFixed(2)
            }}
          </p>
        </div>
      </div>
    </div>

  </div>